import { XIcon, XIconLarge } from '../../../components/icons';
import { GetDateInCurrentTimeZone } from '../../../components/utilities/dateUtilities';
import React, { useEffect, useState } from 'react';
import { ArchivedHeader, OrderedTextStyle, SpanStyle, TextStyle, TopBarStyle } from './LegacyStyles';
import { LegacyOrder } from '../../types';

interface Props {
  legacyOrder: LegacyOrder;
  onHideClick: () => void;
}

const TopBarSlideout = (props: Props) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(false);
  }, []);

  const getSearches = () => {
    let result = '';
    for (let i = 0; i < props.legacyOrder.searches.length; i++) {
      const search = props.legacyOrder.searches[i].search;
      if (i < props.legacyOrder.searches.length - 1) {
        result += `${search.replace(' Search', '')}, `;
      } else {
        result += `${search.replace('Search', '')}`;
      }
    }
    return result;
  };

  return (
    <React.Fragment>
      {!loading && (
        <div>
          <div style={{ position:'absolute', right:24, top:24 }} onClick={() => props.onHideClick()}>
            <XIconLarge stroke="#8E8E93" />
          </div>
          <ArchivedHeader>
            <div>Archived Order: {props.legacyOrder.titleNumber}</div>
          </ArchivedHeader>
          <div style={{ paddingTop: '8px', paddingBottom: '24px' }}>
            <OrderedTextStyle>
              Ordered {GetDateInCurrentTimeZone(props.legacyOrder.receivedDate).format('MM/DD/YYYY')}
            </OrderedTextStyle>
          </div>

          <div>
            <SpanStyle>SEARCHES</SpanStyle>
            <br />
            <TextStyle>{getSearches()}</TextStyle>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
export default TopBarSlideout;
